module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"cancel":"Cancelar","filter":"Filtrar","media":"foto | fotos","select":"Selecionar","selected":"Nenhum selecionado | 1 selecionado | {count} selecionados"}}')
  delete Component.options._Ctor
}
